import { Checkbox, CheckboxProps } from '@nextui-org/react'
import React from 'react'
import {
    Control,
    Controller,
    FieldValues,
    Path,
    RegisterOptions
} from 'react-hook-form'

import { ErrorText } from '@/components/common/UI'

interface CheckboxControlProps<T extends FieldValues>
    extends Omit<CheckboxProps, 'onChange'> {
    name: Path<T>
    control: Control<T>
    rules?: Omit<
        RegisterOptions<T, Path<T>>,
        'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
    >
    onChangeCustom?: (checked: boolean) => void
    label?: React.ReactNode
    classNameLabel?: string
}

export function CheckboxControl<T extends FieldValues>({
    name,
    control,
    rules,
    onChangeCustom,
    label,
    classNameLabel,
    ...props
}: CheckboxControlProps<T>): React.ReactElement {
    return (
        <Controller<T>
            name={name}
            control={control}
            rules={rules}
            defaultValue={false as any}
            render={({
                field: { onChange, value, ...field },
                fieldState: { error }
            }) => (
                <div className="flex flex-col gap-1">
                    <Checkbox
                        {...field}
                        {...props}
                        isSelected={value}
                        onValueChange={(checked) => {
                            onChange(checked)
                            if (onChangeCustom) {
                                onChangeCustom(checked)
                            }
                        }}
                        isInvalid={!!error}
                        classNames={{
                            label: `${classNameLabel || ''}`
                        }}
                    >
                        {label}
                    </Checkbox>
                    {error && <ErrorText error={error.message} />}
                </div>
            )}
        />
    )
}
